'use client';

import { useRollbarPerson } from '@rollbar/react';
import { useAuthStore } from '@/stores/user.store';
import { useThemeStore } from '@/stores/theme.store';

/**
 * Identifies the current user to Rollbar so error reports include
 * id / email / company. Mounted once inside the provider tree after
 * stores have hydrated. Renders nothing.
 */
export function RollbarPersonSync() {
  const user = useAuthStore((s) => s.user);
  const theme = useThemeStore((s) => s.theme);

  useRollbarPerson({
    id: user?.documentId ?? '',
    email: user?.userId ?? user?.contactInfo?.emailAddresses?.[0] ?? '',
    company: theme?.companyName ?? '',
  });

  return null;
}
